import { apiSlice } from "../../app/api/apiSlice";

export const reissueXmlCdoApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		persistReissueXmlCdo: builder.mutation({
			query: (payload) => ({
				url: `/api/v1/loan/credit_reissue_xml_cdo/`,
				method: "POST",
				body: payload,
			}),
		}),
	}),
});

export const { usePersistReissueXmlCdoMutation } = reissueXmlCdoApiSlice;
